import { getGeocoder, getWechatSignatureApi, getSdkInfoApi } from "@/libs/api";
import { types as Home } from "@/store/home";
import store from "@/store";
// 获取版本
let getVerson = (ua, type) => {
  if (type > 0) {
    return 0;
  } else {
    return ua.substring(ua.indexOf(type) + type.length, ua.length).split("_")[3];
  }
};

// 获取主域名
export const uleUrl = () => {
  return process.env.VUE_APP_HOST;
};
// 获取cdn域名
export const uleCdn = () => {
  return process.env.VUE_APP_HOST_CDN;
};
// 获取当前cookie
export const getCookie = (name) => {
  var cookies = document.cookie.split(";");
  for (var i = 0, len = cookies.length; i < len; i++) {
    if (cookies[i].split("=")[0].trim() == name) {
      return cookies[i].split("=")[1];
    }
  }
};
// 设置当前cookie
export const setCookie = (name, val, domain) => {
  document.cookie = name + "=" + val + ";domain=" + domain + ";path=/";
};
// 判断用户是否登陆
export const checkUserStatus = () => {
  if (getCookie("mall_cookie") || getCookie("ul_utk") || location.hostname == "localhost") {
    return true;
  } else {
    return false;
  }
};
// 获取当前client
export const browser = () => {
  let ua = navigator.userAgent.toLowerCase();
  let uappType = {
    ule: false,
    ylxd: false,
    ylxdsq: false,
    yzg: false,
    yzgxd: false,
    zyet: false,
    yzs: false,
    ulemax:false,
    wx: ua.match(/micromessenger/i) && !ua.match(/wxwork/i), //企业微信与微信内都存在micromessenger，所以要多判断一次不存在wxwork，即微信环境下不是企业微信就是微信
    wxwork: ua.match(/wxwork/i),
    miniprogram: !!~ua.indexOf("miniprogram"),
    ios: ua.match(/(iphone|ipod|ipad|ios);?/i),
    android: ua.match(/android/i),
    version: 0,
  };
  // 4合1
  if (ua.match(/ulemax/i)) {
    // 邮乐App
    uappType.version = getVerson(ua, "ulemax/");
    uappType.ulemax = true;
  }
  if (~ua.indexOf("uleapp/")) {
    // 邮乐App
    uappType.version = getVerson(ua, "uleapp/");
    uappType.ule = true;
  }
  // 邮乐小店 App
  if (~ua.indexOf("ulxdapp/") && !~ua.indexOf("ylxdsq")) {
    uappType.version = getVerson(ua, "ulxdapp/");
    uappType.ylxd = true;
  }
  // 邮乐优鲜APP
  if (ua.indexOf("ylxdsq") > -1 && ua.indexOf("ulemax") < 0) {
    uappType.version = getVerson(ua, "ulxdapp/");
    uappType.ylxdsq = true;
  }
  // 邮掌柜APP
  if (~ua.indexOf("uzgapp/")) {
    uappType.version = getVerson(ua, "uzgapp/");
    uappType.yzg = true;
  }
  // 邮掌柜小店APP
  if (~ua.indexOf("uzgxdapp/")) {
    uappType.version = getVerson(ua, "uzgxdapp/");
    uappType.yzgxd = true;
  }
  //中邮易自提APP
  if (~ua.indexOf("zyetapp")) {
    uappType.version = getVerson(ua, "zyetapp");
    uappType.zyet = true;
  }
  //邮助手
  if (~ua.indexOf("yzs")) {
    uappType.version = getVerson(ua, "yzs");
    uappType.yzs = true;
  }
  return uappType;
};
// 判断是否添加js
export const isIncludeJs = (name) => {
  var js = /js$/i.test(name);
  var es = document.getElementsByTagName(js ? "script" : "link");
  for (var i = 0; i < es.length; i++) if (es[i][js ? "src" : "href"].indexOf(name) !== -1) return true;
  return false;
};
// 白名单判断
export const isWhiteList = (to, fn, list) => {
  // 在白名单中
  if (list.indexOf(to.name) !== -1) {
    if (false && (to.name == "home" || to.name == "freshHome")) {
      //2022/6/13   上海调整正常首页
      try {
        let adcode = JSON.parse(getCookie("location")).adcode;
        if (adcode.substring(0, 2) == "31") {
          if (to.name == "freshHome") {
            fn();
          } else {
            fn({
              path: "/freshHome",
              query: to.query,
            });
          }
        } else {
          if (to.name == "home") {
            fn();
          } else {
            fn({
              path: "/",
              query: to.query,
            });
          }
        }
      } catch (error) {
        fn();
      }
    } else {
      fn();
    }
  } else {
    // 判断是否已登录
    if (getCookie("mall_cookie") || getCookie("ul_utk")) {
      fn();
    } else {
      if (browser().miniprogram) {
        window.wx.miniProgram.navigateTo({
          url: "/pages/authorize?target=" + encodeURIComponent(`https://h5.${uleUrl()}/yxd/community/`) + "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
        });
      } else {
        window.location.href = `//m.${uleUrl()}/muser/user/login?target=https://h5.${uleUrl()}/yxd/community/`;
      }
    }
  }
};
// 定位获取
export const getPosition = (to, next, list, Toast, Dialog) => {
  let timer; // H5定位定时器
  // 小程序环境
  if (browser().miniprogram) {  
    console.log('进入小程序')
    // 当前的定位
    let currentPos = {
      currentCity: "",
      addr: "",
      location: "",
    };
    // 当前的adcode
    let currentAdcode = "";
    // 缓存中的定位
    let storePos = {
      currentCity: store.getters[Home.CURRENT_CITY_MIN].currentCity,
      addr: store.getters[Home.CURRENT_CITY_MIN].addr,
      location: store.getters[Home.CURRENT_CITY_MIN].location,
    };
    // 缓存中的adcode
    let storeAdcode = store.getters[Home.AD_CODE_MIN];
    // 存入cookies的定位
    let cookiesPos = {};
    // 获取地址上的参数
    if(to.query.adcode){
      let adcode = to.query.adcode;
      let latng = to.query.latng;
      let position = {
        location:latng,
        adcode: adcode,
      };
      console.log('to.query',to.query)
      console.log('小程序position',position)
      console.log('JSON.stringify(position)',JSON.stringify(position),uleUrl())
      document.cookie = `location=${JSON.stringify(position)};domain=.${uleUrl()};path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    }
    // 手动选择
    else if (to.query.trigger === "2") {
      currentPos.currentCity = to.query.addr;
      currentPos.addr = to.query.addr;
      currentPos.location = `${to.query.lat},${to.query.lng}`;
      currentAdcode = to.query.adcode;
      cookiesPos = {
        location: currentPos.location,
        adcode: currentAdcode,
      };
      store.commit(Home.CURRENT_CITY_MIN, currentPos);
      store.commit(Home.AD_CODE_MIN, currentAdcode);
      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.ule.com;path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    }
    // 授权定位
    else if (to.query.trigger === "1") {
      currentPos.currentCity = to.query.addr;
      currentPos.addr = to.query.addr;
      currentPos.location = `${to.query.lat},${to.query.lng}`;
      currentAdcode = to.query.adcode;
      // 有缓存
      if (storeAdcode) {
        // 如果定位一致
        if (storeAdcode === to.query.adcode || to.name != "home") {
          store.commit(Home.CURRENT_CITY_MIN, currentPos);
          store.commit(Home.AD_CODE_MIN, currentAdcode);
          cookiesPos = {
            location: currentPos.location,
            adcode: currentAdcode,
          };
          document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.ule.com;path=/;`;
          setTimeout(() => {
            isWhiteList(to, next, list);
          }, 500);
        }
        // 如果不一致
        else {
          // 取消则是缓存中的定位
          cookiesPos = {
            location: storePos.location,
            adcode: storeAdcode,
          };
          document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.ule.com;path=/;`;
          setTimeout(() => {
            isWhiteList(to, next, list);
          }, 500);
        }
      }
      // 无缓存
      else {
        cookiesPos = {
          location: currentPos.location,
          adcode: currentAdcode,
        };
        store.commit(Home.CURRENT_CITY_MIN, currentPos);
        store.commit(Home.AD_CODE_MIN, currentAdcode);
        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.ule.com;path=/;`;
        setTimeout(() => {
          isWhiteList(to, next, list);
        }, 500);
      }
    }
    // 无定位参数
    else {
      console.log("定位不变");
      let position = {
        location: storePos.location,
        adcode: storeAdcode,
      };
      document.cookie = `location=${JSON.stringify(position)};domain=.${uleUrl()};path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    }
  } else if (browser().yzs) {
    window.dsBridge.call("getLocationMsg", "", function(e) {
      e = JSON.parse(e);
      console.log("eeeeee", e);
      let currentAdcode = e.cityCode;
      store.commit(Home.AD_CODE, currentAdcode);
      let cookiesPos = {
        location: `${e.latitude},${e.longitude}`,
        adcode: currentAdcode,
      };
      console.log("adcode", cookiesPos.adcode);
      console.log("location", cookiesPos.location);
      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.ule.com;path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    });
  }
  // 优鲜app、邮乐app、邮乐小店app
  else if (browser().ylxdsq || browser().ule || browser().ylxd || browser().ulemax) {
    // isWhiteList(to, next, list);
    window.dsBridge.register("getCurrentCityCode", (e) => {
      e = JSON.parse(e);
      console.log('app方法获取的定位',e)
      let currentAdcode = e.cityCode;
      store.commit(Home.AD_CODE, currentAdcode);
      isWhiteList(to, next, list);
    });
    window.dsBridge.call("getCurrentCityCode", { ios_action: "getCurrentCityCode", android_action: "getCurrentCityCode", minversion: "207", maxversion: "999" });
  } else if (browser().yzg) {
    isWhiteList(to, next, list);
    window.dsBridge.call("getLocationMsg", "", function(e) {
      e = JSON.parse(e);
      console.log("eeeeee", e);
      let currentAdcode = e.cityCode;
      store.commit(Home.AD_CODE, currentAdcode);
      let cookiesPos = {
        location: `${e.latitude},${e.longitude}`,
        adcode: currentAdcode,
      };
      console.log("adcode", cookiesPos.adcode);
      console.log("location", cookiesPos.location);
      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    });
  }
  // 微信环境
  else if (browser().wx) {
    console.log("当前是微信环境");
    let currentAdcode = "";
    let currentPos = {
      currentCity: "",
      addr: "",
      location: "",
    };
    let cookiesPos = "";
    let storeAdcode = store.getters[Home.AD_CODE];
    let storePos = {
      currentCity: store.getters[Home.CURRENT_CITY].currentCity,
      addr: store.getters[Home.CURRENT_CITY].addr,
      location: store.getters[Home.CURRENT_CITY].location,
    };
    let appid = "";
    console.log("storePos====", storePos);
    if (process.env.NODE_ENV === "development") {
      appid = "wx4e190edda7e57237";
    } else if (process.env.NODE_ENV === "testing") {
      appid = "wx4e190edda7e57237";
    } else if (process.env.NODE_ENV === "production") {
      appid = "wx4e190edda7e57237";
    }
    var data = {
      lotteryInfoId: "325",
      currentPageUrl: location.href,
      // currentPageUrl : 'https://h5.ule.com/yxd/community/',
      appkey: "4b9f40822ddd5cd5",
      version_no: "apr_2010_build01",
      appId: appid,
      t: Math.random(),
    };
    let getAdcodeData = {
      key: "OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4",
      callbackName: "QQmap",
      output: "jsonp",
      location: "",
      get_poi: 1,
    };
    console.log("appid========", appid);
    console.log("data============", data);
    // 地址上带有参数
    if (to.query.name && to.query.module) {
      console.log("应该走这里的");
      currentPos.currentCity = to.query.city || to.query.name;
      currentPos.addr = to.query.addr || to.query.name;
      currentPos.location = to.query.latng;
      getAdcodeData.location = currentPos.location;
      getGeocoder(getAdcodeData, "", "callback").then((res) => {
        cookiesPos = {
          location: to.query.latng,
          adcode: res.result.ad_info.adcode,
        };
        currentAdcode = res.result.ad_info.adcode;
        store.commit(Home.CURRENT_CITY, currentPos);
        store.commit(Home.AD_CODE, currentAdcode);
        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
        isWhiteList(to, next, list);
      });
    }
    // 无参数
    else {
      getWechatSignatureApi(data).then((res) => {
        if (res.returnCode == "0000") {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appid, // 必填，公众号的唯一标识
            timestamp: res.detail[0].timestamp, // 必填，生成签名的时间戳
            nonceStr: res.detail[0].nonceStr, // 必填，生成签名的随机串
            signature: res.detail[0].signature, // 必填，签名
            jsApiList: ["getLocation", "openLocation"], // 必填，需要使用的JS接口列表
          });
          wx.ready(function() {
            wx.getLocation({
              type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function(res) {
                console.log("res=============", res);
                var latitude = Number(res.latitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                var longitude = Number(res.longitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                console.log("latitude====", latitude);
                console.log("longitude====", longitude);
                let location = `${latitude},${longitude}`;
                getAdcodeData.location = location;
                console.log("getAdcodeData===", getAdcodeData);
                getGeocoder(getAdcodeData, "", "callback").then((res) => {
                  currentAdcode = res.result.ad_info.adcode;
                  currentPos.currentCity = res.result.address_component.city;
                  currentPos.addr = res.result.address;
                  currentPos.location = location;
                  // 缓存中有定位
                  if (storeAdcode) {
                    // 判断是否一致
                    if (storeAdcode === currentAdcode) {
                      console.log("adcode一致");
                      cookiesPos = {
                        location: location,
                        adcode: currentAdcode,
                      };
                      store.commit(Home.CURRENT_CITY, currentPos);
                      store.commit(Home.AD_CODE, currentAdcode);
                      console.log("currentPos", currentPos);
                      console.log("currentAdcode", currentAdcode);
                      console.log("cookiesPos", cookiesPos);
                      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                      isWhiteList(to, next, list);
                    }
                    // 与缓存定位不一致
                    else {
                      console.log("走了这里");
                      // 直接取缓存中的定位
                      cookiesPos = {
                        location: storePos.location,
                        adcode: storeAdcode,
                      };
                      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                      isWhiteList(to, next, list);
                    }
                  }
                  // 缓存中没有定位，取自动定位
                  else {
                    console.log("是不是走了else");
                    cookiesPos = {
                      location: location,
                      adcode: currentAdcode,
                    };
                    console.log("cookiesPos====", cookiesPos);
                    console.log("currentPos====", currentPos);
                    console.log("currentAdcode====", currentAdcode);
                    store.commit(Home.CURRENT_CITY, currentPos);
                    store.commit(Home.AD_CODE, currentAdcode);
                    document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                    isWhiteList(to, next, list);
                  }
                });
              },
              fail: function(err) {
                console.log("err", err);
                let location = store.getters[Home.CURRENT_CITY].location || "";
                console.log("location====", location);
                if (location) {
                  Toast.clear();
                  console.log("有定位了");
                  isWhiteList(to, next, list);
                } else {
                  Toast("无法获取位置，请手动定位");
                  next({
                    path: "/others/positionLost",
                    query: { target: to.fullPath },
                  });
                }
              },
              cancel: function(cal) {
                console.log("cal=====", res);
                let location = store.getters[Home.CURRENT_CITY].location || "";
                console.log("location====", location);
                if (location) {
                  console.log("有定位了");
                  Toast.clear();
                  isWhiteList(to, next, list);
                } else {
                  Toast("无法获取位置，请手动定位");
                  next({
                    path: "/others/positionLost",
                    query: { target: to.fullPath },
                  });
                }
              },
            });
          });
          // wxConfig(o.detail[0].timestamp, o.detail[0].nonceStr, o.detail[0].signature);
        } else {
          let location = store.getters[Home.CURRENT_CITY].location || "";
          console.log("location====", location);
          if (location) {
            Toast.clear();
            console.log("有定位了");
            isWhiteList(to, next, list);
          } else {
            Toast("无法获取位置，请手动定位");
            next({
              path: "/others/positionLost",
              query: { target: to.fullPath },
            });
          }
        }
      });
    }
  }
  // 企业微信环境
  else if (browser().wxwork) {
    console.log("当前是企业微信环境");
    let currentAdcode = "";
    let currentPos = {
      currentCity: "",
      addr: "",
      location: "",
    };
    let cookiesPos = "";
    let storeAdcode = store.getters[Home.AD_CODE];
    let storePos = {
      currentCity: store.getters[Home.CURRENT_CITY].currentCity,
      addr: store.getters[Home.CURRENT_CITY].addr,
      location: store.getters[Home.CURRENT_CITY].location,
    };
    let saleManId = "";
    // 判断是否有bsc信息
    if (getCookie("ul_union")) {
      saleManId = getCookie("ul_union");
      saleManId = decodeURIComponent(saleManId).split("|")[2];
    }
    // console.log('ul====11111',getCookie('ul_union'))
    // console.log('to.query.saleManId',saleManId)
    let getAdcodeData = {
      key: "OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4",
      callbackName: "QQmap",
      output: "jsonp",
      location: "",
      get_poi: 1,
    };
    let data = {
      saleManId,
      currentUrl: encodeURIComponent(location.href),
    };
    // 地址上带有参数
    if (to.query.name && to.query.module) {
      currentPos.currentCity = to.query.city || to.query.name;
      currentPos.addr = to.query.addr || to.query.name;
      currentPos.location = to.query.latng;
      getAdcodeData.location = currentPos.location;
      getGeocoder(getAdcodeData, "", "callback").then((res) => {
        cookiesPos = {
          location: to.query.latng,
          adcode: res.result.ad_info.adcode,
        };
        currentAdcode = res.result.ad_info.adcode;
        store.commit(Home.CURRENT_CITY, currentPos);
        store.commit(Home.AD_CODE, currentAdcode);
        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
        isWhiteList(to, next, list);
      });
    }
    // 无参数
    else {
      getSdkInfoApi(data).then((res) => {
        console.log(res);
        if (res.returnCode == "0000") {
          var share = res.data;
          wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false,
            appId: share.appId,
            timestamp: share.timestamp,
            nonceStr: share.nonceStr,
            signature: share.signature,
            jsApiList: ["getLocation", "openLocation"], // 必填，需要使用的JS接口列表
          });
          wx.agentConfig({
            corpid: share.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: share.agentid, // 必填，企业微信的应用id （e.g. 1000247）
            timestamp: share.timestamp, // 必填，生成签名的时间戳
            nonceStr: share.nonceStr, // 必填，生成签名的随机串
            signature: share.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
            jsApiList: ["getLocation", "openLocation"], // 必填，需要使用的JS接口列表
            success: function(res) {
              // 回调
              // alert('成功8')
            },
            fail: function(res) {
              if (res.errMsg.indexOf("function not exist") > -1) {
                alert("版本过低请升级");
              }
            },
          });
          wx.ready(function() {
            setTimeout(() => {
              wx.getLocation({
                type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function(res) {
                  console.log("res=============", res);
                  var latitude = Number(res.latitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                  var longitude = Number(res.longitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                  console.log("latitude====", latitude);
                  console.log("longitude====", longitude);
                  let location = `${latitude},${longitude}`;
                  getAdcodeData.location = location;
                  console.log("getAdcodeData===", getAdcodeData);
                  getGeocoder(getAdcodeData, "", "callback").then((res) => {
                    currentAdcode = res.result.ad_info.adcode;
                    currentPos.currentCity = res.result.address_component.city;
                    currentPos.addr = res.result.address;
                    currentPos.location = location;
                    // 缓存中有定位
                    if (storeAdcode) {
                      // 判断是否一致
                      if (storeAdcode === currentAdcode) {
                        console.log("adcode一致");
                        cookiesPos = {
                          location: location,
                          adcode: currentAdcode,
                        };
                        store.commit(Home.CURRENT_CITY, currentPos);
                        store.commit(Home.AD_CODE, currentAdcode);
                        console.log("currentPos", currentPos);
                        console.log("currentAdcode", currentAdcode);
                        console.log("cookiesPos", cookiesPos);
                        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                        isWhiteList(to, next, list);
                      }
                      // 与缓存定位不一致
                      else {
                        console.log("走了这里");
                        // 直接取缓存中的定位
                        cookiesPos = {
                          location: storePos.location,
                          adcode: storeAdcode,
                        };
                        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                        isWhiteList(to, next, list);
                      }
                    }
                    // 缓存中没有定位，取自动定位
                    else {
                      // console.log('是不是走了else')
                      cookiesPos = {
                        location: location,
                        adcode: currentAdcode,
                      };
                      console.log("cookiesPos====", cookiesPos);
                      console.log("currentPos====", currentPos);
                      console.log("currentAdcode====", currentAdcode);
                      store.commit(Home.CURRENT_CITY, currentPos);
                      store.commit(Home.AD_CODE, currentAdcode);
                      document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                      isWhiteList(to, next, list);
                    }
                  });
                },
                fail: function(err) {
                  console.log("err", err);
                  Toast("无法获取位置，请手动定位");
                  next({
                    path: "/others/positionLost",
                    query: { target: to.fullPath },
                  });
                },
                cancel: function(cal) {
                  console.log("cal=====", res);
                  Toast("无法获取位置，请手动定位");
                  next({
                    path: "/others/positionLost",
                    query: { target: to.fullPath },
                  });
                },
              });
            }, 1000);
          });
          // wxConfig(o.detail[0].timestamp, o.detail[0].nonceStr, o.detail[0].signature);
        } else {
          console.log("自己选定位");
          Toast("无法获取位置，请手动定位");
          next({
            path: "/others/positionLost",
            query: { target: to.fullPath },
          });
        }
      });
    }
  }
  // H5环境
  else {
    console.log(333333333333)
    // console.log('有没有进H5这里')
    // 逆向获取adcode参数
    let getAdcodeData = {
      key: "OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4",
      callbackName: "QQmap",
      output: "jsonp",
      location: "",
      get_poi: 1,
    };
    // 当前的定位
    let currentPos = {
      currentCity: "",
      addr: "",
      location: "",
    };
    // 当前的adcode
    let currentAdcode = "";
    // 缓存中的定位
    let storePos = {
      currentCity: store.getters[Home.CURRENT_CITY].currentCity,
      addr: store.getters[Home.CURRENT_CITY].addr,
      location: store.getters[Home.CURRENT_CITY].location,
    };
    // 缓存中的adcode
    let storeAdcode = store.getters[Home.AD_CODE];
    // 存入cookies的定位
    let cookiesPos = {};
    // 地址上带有参数
    if (to.query.name && to.query.module) {
      // console.log('应该走这里的')
      currentPos.currentCity = to.query.city || to.query.name;
      currentPos.addr = to.query.addr || to.query.name;
      currentPos.location = to.query.latng;
      getAdcodeData.location = currentPos.location;
      getGeocoder(getAdcodeData, "", "callback").then((res) => {
        cookiesPos = {
          location: to.query.latng,
          adcode: res.result.ad_info.adcode,
        };
        currentAdcode = res.result.ad_info.adcode;
        store.commit(Home.CURRENT_CITY, currentPos);
        store.commit(Home.AD_CODE, currentAdcode);
        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
        isWhiteList(to, next, list);
      });
    }
    else if(to.query.adcode && to.query.latng){
      let adcode = to.query.adcode;
      let latng = to.query.latng;
      let position = {
        location:latng,
        adcode: adcode,
      };
      console.log('to.query',to.query)
      document.cookie = `location=${JSON.stringify(position)};domain=.${uleUrl()};path=/;`;
      setTimeout(() => {
        isWhiteList(to, next, list);
      }, 500);
    }
    // 地址上无参数
    else {
      console.log('是不是走这里',to)
      // 接龙不定位，直接下去
      if(to.name == 'chainsDetail'){
        isWhiteList(to, next, list);
      }else{
        Toast.loading({
          duration: 0,
          mask: true,
          message: "获取定位中...",
        });
        let location = store.getters[Home.CURRENT_CITY].location || "";
        console.log("location====", location);
        if (location) {
          Toast.clear();
          console.log("有定位了");
          isWhiteList(to, next, list);
        } else {
          // 获取H5原生定位
          if (navigator.geolocation) {
            timer = setTimeout(() => {
              Toast("无法获取位置，请手动定位");
              next({
                path: "/others/positionLost",
                query: { target: to.fullPath },
              });
            }, 5000);
            navigator.geolocation.getCurrentPosition(
              // 定位成功
              function(posi) {
                clearTimeout(timer);
                let lat = posi.coords.latitude;
                let lng = posi.coords.longitude;
                let latng = posi.coords.latitude + "," + posi.coords.longitude;
                let cityLocation = new window.qq.maps.CityService({
                  complete: (res) => {
                    Toast.clear();
                    currentPos.currentCity = res.detail.detail;
                    currentPos.addr = res.detail.detail;
                    currentPos.location = `${res.detail.latLng.lat},${res.detail.latLng.lng}`;
                    getAdcodeData.location = currentPos.location;
                    getGeocoder(getAdcodeData, "", "callback").then((res) => {
                      currentAdcode = res.result.ad_info.adcode;
                      // 缓存中有定位
                      if (storeAdcode) {
                        // 判断是否一致
                        if (storeAdcode === currentAdcode) {
                          console.log("adcode一致");
                          cookiesPos = {
                            location: currentPos.location,
                            adcode: currentAdcode,
                          };
                          store.commit(Home.CURRENT_CITY, currentPos);
                          store.commit(Home.AD_CODE, currentAdcode);
                          console.log("currentPos", currentPos);
                          console.log("currentAdcode", currentAdcode);
                          console.log("cookiesPos", cookiesPos);
                          document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                          isWhiteList(to, next, list);
                        }
                        // 与缓存定位不一致
                        else {
                          // 直接取缓存中的定位
                          cookiesPos = {
                            location: storePos.location,
                            adcode: storeAdcode,
                          };
                          document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                          isWhiteList(to, next, list);
                        }
                      }
                      // 缓存中没有定位，取自动定位
                      else {
                        cookiesPos = {
                          location: currentPos.location,
                          adcode: currentAdcode,
                        };
                        store.commit(Home.CURRENT_CITY, currentPos);
                        store.commit(Home.AD_CODE, currentAdcode);
                        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=.${uleUrl()};path=/;`;
                        isWhiteList(to, next, list);
                      }
                    });
                  },
                });
                // setError 设置检索失败后的回调函数。
                cityLocation.setError(() => {
                  Toast("出错了，没有获得正确的定位！！！");
                  next({
                    path: "/others/positionLost",
                    query: { target: to.fullPath },
                  });
                });
                if (lat != 0 && lng != 0) {
                  let latLng = new window.qq.maps.LatLng(lat, lng);
                  cityLocation.searchCityByLatLng(latLng);
                }
              },
              // 定位失败
              function(error) {
                clearTimeout(timer);
                Toast("无法获取位置，请手动定位");
                next({
                  path: "/others/positionLost",
                  query: { target: to.fullPath },
                });
              }
            );
          } else {
            Toast("无法获取位置，请手动定位");
            next({
              path: "/others/positionLost",
              query: { target: to.fullPath },
            });
          }
        }
      }
     
    }
  }
};
// 判断当前环境cookies存入相应值
export const setClientType = (to) => {
  // 获取当前client_type
  let currentClientType = getCookie("ul_sch") || getCookie("client_type");
  let isMinWx = browser().miniprogram ? "miniwx_ylxdsq" : null;
  let isYlxdsq = browser().ylxdsq ? "app_ylxdsq" : null;
  let isYzgxd = browser().yzgxd ? "app_yzgxd" : null;
  let isYzg = browser().yzg ? "app_ylxdsq" : null;
  let clientType = "wap_ylxdsq"; // 默认H5
  // 生鲜小程序
  if (isMinWx) {
    clientType = "miniwx_ylxdsq";
  }
  // 生鲜APP
  else if (isYlxdsq || isYzg) {
    clientType = "app_ylxdsq";
  }
  // 邮掌柜小店
  else if (isYzgxd) {
    clientType = "app_yzgxd";
  } else if (browser().ule) {
    //邮乐网APP
    clientType = "app_ylw";
  } else if (to.query.client_type || to.query.ul_sch) {
    clientType = to.query.client_type || to.query.ul_sch;
  }
  let setClient = function(client) {
    document.cookie = `ul_sch=${client};domain=.${uleUrl()};path=/;`;
  };
  // 已存在cookies
  if (currentClientType) {
    if (currentClientType === isMinWx || currentClientType === isYlxdsq) {
      console.log("client_type", currentClientType);
    } else {
      setClient(clientType);
    }
  } else {
    setClient(clientType);
  }
};

// 校验手机号
export const isPhone = (mobile) => {
  if (!/^1[3456789]\d{9}$/.test(mobile)) {
    return false;
  } else {
    return true;
  }
};
// 固定电话
export const isTel = (tel) => {
  if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(tel)) {
    return false;
  } else {
    return true;
  }
};
export function simpleDebounce(fn, delay = 100) {
  let timer = null;
  return function() {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 防抖
export function debounce(fn, delay) {
  let timer;
  return () => {
    if (timer) {
      clearTimeout(timer);
    }
    console.log("timer", timer);
    timer = setTimeout(() => {
      fn();
    }, delay);
  };
}

//获取系统时间
export function systemTime(fn) {
  let sysTime = 0;
  let difference = 0;
  let now = new Date().getTime();
  // 如果本机时间和服务器时间差超过三分钟则获取服务器时间，否则取本机时间
  let request = new XMLHttpRequest();
  request.open("GET", "https://clock.ule.com/now/?_=" + new Date().getTime(), false);
  request.send();
  if (request.status === 200) {
    sysTime = request.response * 1000;
    // difference = sysTime - now;
    console.log("获取当前系统时间", sysTime);
    if (fn) fn(sysTime);
  }
}
// 神策曝光
export function scExposure(domId, myCallback) {
  let uploadLog = [];
  let isFirst = true;
  const callBack = (entries, observer) => {
    // 第一次触发显示时会给所有的元素
    if (isFirst) {
      entries.forEach((item) => {
        let index = item.target.dataset.index;
        uploadLog[index] = {
          isPush: false, // 是否上报过
          timer: -1, // 用于存储定时器编号
        };
      });
      isFirst = false;
    }
    entries.forEach((item) => {
      let index = item.target.dataset.index;
      // 先判断当前元素是否已经上报过日志
      if (uploadLog[index].isPush) {
        return false; // 上报过直接 直接退出
      }
      if (item.isIntersecting) {
        // 开始计时, 5秒后添加神策数据

        uploadLog[index].timer = setTimeout((_) => {
          myCallback(index);
          // 上报完成后，状态修改为 true,避免重复上报
          uploadLog[index].isPush = true;
        }, 5000);
      } else {
        // 如果元素移动出可视区域后，清除定时器
        if (uploadLog[index].timer) clearTimeout(uploadLog[index].timer);
      }
    });
  };
  const observer = new IntersectionObserver(callBack, { threshold: 0.99 });
  const liList = document.querySelectorAll(domId);
  liList.forEach((item) => {
    observer.observe(item);
  });
}
